import { Abi, Address } from 'viem';
import { mainnet } from 'viem/chains';

import { MZUSD_ABI } from './abi/MZUSD_ABI';
import { TRANCHE_ABI } from './abi/TRANCHE_ABI';
import { VAULT_ABI } from './abi/VAULT_ABI';

export const USDC: Address = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48';

export const WYLDS: Address = '0x6aD038cA6C04e885630851278ca0a856Ad9a66Cc';

export const ALLOWLIST_ADDRESS: Address = '0xE417cdb4c52F759F3Ff97bA19bAF0C35402Fb641';

export const VAULT: Address = '0x55a0cb0CACBaDD0fe92571768cc256E92F1b857d';
export const SENIOR_TRANCHE: Address = '0x81C843aF16440aC3073957ff01c9022FE731Ed69';
export const JUNIOR_TRANCHE: Address = '0x95A3956dd49BD5eFE7bF3eDB199ddEcc68057695';
export const MZUSD: Address = '0x21535333aD58487d4D93627b7497E38480f2fC0b';
export const RESERVIOS_USDC: Address = '0xa2Dd78fa93571E54fc19F46e64bda65904CdF332';

export const HASTRA_VAULT: Address = '0xBB03549117e38103589774AE1D6338D1B237FFA2';
export const HASTRA_SENIOR_TRANCHE: Address = '0x0e246e5FA94E90ab784b03961C35AaD9999b6649';
export const HASTRA_JUNIOR_TRANCHE: Address = '0x6F5d94Dc0c8bBf052aBF024259d087dA45AD96A1';
export const HASTRA_MZUSD: Address = '0x1BBa049d3869E8d467F38E52AcA8E99D64E310a6';
export const HASTRA_RESERVOIR: Address = '0x43bC5fB52A618F0F2efb0d68Cf900Bb2FbD8a501';

export const SENIOR_TRANCHE_ID = SENIOR_TRANCHE.toLowerCase();
export const JUNIOR_TRANCHE_ID = JUNIOR_TRANCHE.toLowerCase();
export const VAULT_ID = VAULT.toLowerCase();
export const HASTRA_VAULT_ID = HASTRA_VAULT.toLowerCase();

export const VALID_TRANCHE_IDS = [
  SENIOR_TRANCHE_ID,
  JUNIOR_TRANCHE_ID,
  HASTRA_SENIOR_TRANCHE.toLowerCase(),
  HASTRA_JUNIOR_TRANCHE.toLowerCase(),
];

export const ABI = {
  MZUSD: MZUSD_ABI,
  TRANCHE: TRANCHE_ABI,
  VAULT: VAULT_ABI,
} as const satisfies Record<string, Abi>;

export const ABI_ERROR: Abi = Object.values(ABI).reduce<Abi>((acc, abi) => {
  if (!Array.isArray(abi)) return acc;
  const errors = abi.filter((item) => item.type === 'error');
  return [...acc, ...errors];
}, [] as Abi);

export const RPC_NODES = {
  [mainnet.id]: [
    'https://twilight-fluent-pool.ethereum-mainnet.quiknode.pro/912b90393eadaf6975252fcaeb8f4c50072e069d/',
  ],
} as const;
